import { useSetting } from "@faire/deprecated-retailer-visitor-shared/settings/__internal__/useSetting";
import { FE_DISCOVER_PAGE_SECTIONAL_DESIGN_V2_250708 } from "@faire/retailer-settings/FE_DISCOVER_PAGE_SECTIONAL_DESIGN_V2_250708";

export const useSettingDiscoverPageSectionalDesign = (): boolean => {
  return useSetting(FE_DISCOVER_PAGE_SECTIONAL_DESIGN_V2_250708);
};
